import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Proptypes from 'prop-types';
import { Button } from 'react-bootstrap';
import styles from './ModalComponent.module.css';

// eslint-disable-next-line no-unused-vars
const ModalComponent = React.forwardRef((props, ref) => {
  const {
    show,
    confirmButtonText,
    confirmButtonAction,
    showConfirmCallToAction,
    close,
    size,
    isBtnDisabled,
    actionBtnIcon,
    centered,
  } = props;

  const [showModal, setShowModal] = useState();

  React.useEffect(() => {
    setShowModal(show);
  }, [show]);

  const handleClose = () => {
    setShowModal(false);
    close();
  };

  return (
    <Modal
      size={size}
      show={showModal}
      dialogClassName={styles.customModalClass}
      onHide={handleClose}
      fullscreen="md-down"
      centered={centered}
    >
      <>
        {props.children}
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Close</Button>
          {showConfirmCallToAction
              && (
              <Button
                variant="primary"
                className="ModalButton"
                disabled={isBtnDisabled}
                onClick={confirmButtonAction}
              >
                <span>
                  {actionBtnIcon}
                  {' '}
                  {confirmButtonText}
                </span>
              </Button>
              )}

        </Modal.Footer>
      </>
    </Modal>
  );
});

ModalComponent.defaultProps = {
  confirmButtonText: '',
  confirmButtonAction: null,
  size: '',
  isBtnDisabled: false,
  actionBtnIcon: null,
  centered: false,
};

ModalComponent.propTypes = {
  size: Proptypes.string,
  show: Proptypes.bool.isRequired,
  isBtnDisabled: Proptypes.bool,
  confirmButtonText: Proptypes.string,
  confirmButtonAction: Proptypes.func,
  showConfirmCallToAction: Proptypes.bool.isRequired,
  close: Proptypes.func.isRequired,
  actionBtnIcon: Proptypes.element,
  centered: Proptypes.bool,
};

export default ModalComponent;
